import logger from '@/utils/logger';
import http from '../utils/http';

const actions = {
  followUser(store, uid) {
    console.log('calling followUser: ', uid);
    return http
      .post('community.UserSrv/Follow', {
        uid,
      })
      .then((data) => {
        console.log('community.UserSrv/Follow result: ', data);
        return data;
      })
      .catch((err) => {
        // 重复关注也要返回正常 21000
        if (err && err.ret === 21000) {
          return err;
        }
        throw err;
      });
  },

  unfollowUser(store, uid) {
    return http
      .post('community.UserSrv/CancelFollow', {
        uid,
      })
      .then((data) => {
        console.log('community.UserSrv/CancelFollow result: ', data);
        return data;
      })
      .catch((err) => {
        // 未关注取消关注也要返回正常 21008
        if (err && err.ret === 21008) {
          return err;
        }
        throw err;
      });
  },
  postActionReq(store, postData = {}) {
    const {
      postId,
      postCreatorId,
      userId,
      groupId,
      postType,
      action,
      info,
    } = postData;
    return http
      .post('community.PostSrv/PostAction', {
        post_id: postId,
        post_creator_id: postCreatorId || 0,
        user_id: userId || 0,
        group_id: groupId || 0,
        post_type: postType || 0,
        action,
        info,
      })
      .then((data) => {
        console.log('community.PostSrv/postActionReq result: ', data);
        return data;
      })
      .catch((err) => {
        console.log('postActionReq failed: ', err);
        throw err;
      });
  },
  postDeleteReq(store, postData = {}) {
    const { postId, userId } = postData;
    return http
      .post('community.PostSrv/DeletePost', {
        post_id: postId,
        user_id: userId,
      })
      .then((data) => {
        console.log('community.PostSrv/DeletePost result: ', data);
        return data;
      });
  },

  batchDelReadHistory(store, postData = {}) {
    const { uid, postIdList, deleteAll } = postData;
    console.log('batchDelReadHistory: ', postData);
    return http
      .post('community.PostSrv/BatchDelReadHistory', {
        user_id: uid,
        post_id_list: postIdList,
        delete_all: deleteAll,
      })
      .then((data) => {
        console.log('community.PostSrv/BatchDelReadHistory result: ', data);
        return data;
      });
  },
  getMissionConfig(store, type) {
    return http
      .post('community.MissionSrv/GetMissionConfig', {
        type,
      })
      .then((data) => {
        console.log('community.MissionSrv/GetMissionConfigReq result: ', data);
        return data;
      });
  },
  missionNotify(store, uid) {
    return http.post('community.MissionSrv/MNotify', {
      uid,
    });
  },
  sign(store, uid) {
    return http.post('community.MissionSrv/SignDaily', {
      uid,
    });
  },
  mergeRequests(store, requests) {
    requests.forEach((item) => {
      item.method = 'POST';
      item.body = item.body ? JSON.stringify(item.body) : '{}';
    });
    return http.postMerge(requests).then(data => data)
      .catch((err) => {
        throw err;
      });
  },
  addPreRequest({ commit }, { preRequest }) {
    logger.info('addPreRequest', preRequest);
    commit('addPreRequest', { preRequest });
  },
};

export default actions;
